import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Joyride from 'react-joyride';

import { updateSessionUser } from '~/actions/sessions'


class Onboarding extends React.Component {
    static propTypes = {
		page: PropTypes.string
	};

    static contextTypes = {
		store: PropTypes.object
	};

    shouldComponentUpdate() {
		return false;
	}

    callback = (data) => {

		if( data.type !== 'finished' ) return;

		var obj = {};
		obj[ 'completed_onboarding_' + this.props.page ] = 1;

		this.context.store.dispatch( updateSessionUser( {}, obj, {}, true) )

	};

    render() {

		let stepPages = require('./steps'),
			steps = this.props.page in stepPages ? stepPages[this.props.page] : [];

		return <Joyride
			ref={"onboarding-"+this.props.page}
			steps={steps}
			showStepsProgress={true}
			showSkipButton={true}
			autoStart={true}
			run={true}
			type="continuous"
			locale={{ back: 'Back', close: 'Close', last: 'Finish', next: 'Next', skip: 'Skip' }}
			callback={this.callback}
			holePadding={10}
		/>

	}
}

export default Onboarding



// WEBPACK FOOTER //
// ./src/js/components/Onboarding/index.js